/**
 * @generated SignedSource<<5427273b48653cc6e1c9f53bf4552105>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PositionsPortfolioFragment$data = {
  readonly credit: {
    readonly accounts: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"BorrowPositionsTableFragment">;
    }> | null | undefined;
  };
  readonly " $fragmentType": "PositionsPortfolioFragment";
};
export type PositionsPortfolioFragment$key = {
  readonly " $data"?: PositionsPortfolioFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PositionsPortfolioFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PositionsPortfolioFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GhostCreditAccounts",
      "kind": "LinkedField",
      "name": "credit",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GhostCreditAccount",
          "kind": "LinkedField",
          "name": "accounts",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BorrowPositionsTableFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "26ede59054c6296a99c0216bb2b4ceb1";

export default node;
